import { connect } from 'react-redux';
import { redux } from '../api';

import ReportList from './ReportList.js';
const { setCurrentSearchInfo } = redux.actions;
const { setApplicationInfo } = redux.actions;
const mapStateToProps = state => {
  return {
    user: state.api.user.ctInfo,
    // current: state.api.current,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCurrentSearchInfoData: data => {
      dispatch(setCurrentSearchInfo(data));
    },
    setApplicationData: data => {
      dispatch(setApplicationInfo(data));
    },
  };
};

const ConnectedReportList = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportList);

export default ConnectedReportList;
